import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  preparePapAffiliateInBrowserUrl,
  trackPostAffiliateClick,
} from "../utils/postAffiliatePro";

/**
 * PAP click tracking on every SPA navigation (same as Koverx).
 * Initial page load is also tracked from public/index.html.
 */
function PostAffiliateTracker() {
  const location = useLocation();

  useEffect(() => {
    preparePapAffiliateInBrowserUrl();
    trackPostAffiliateClick();
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default PostAffiliateTracker;
